/**
 * Loading fallback for code splitting.
 */

import React from 'react';

export function Loading() {
  return (
    <div className="loading" role="status" data-testid="loading">
      Loading...
    </div>
  );
}
